module.exports = __webpack_public_path__ + "static/media/varais-11-copia.2da39828.jpg";